import { render, staticRenderFns } from "./EmbedYoutube.vue?vue&type=template&id=05b567c9&lang=pug"
import script from "./EmbedYoutube.vue?vue&type=script&lang=js"
export * from "./EmbedYoutube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports